var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowsIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.16 69.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000000;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Zas\xF3b 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28,46.62a17,17,0,0,0-14.42-8h-2v2.89L3.16,34.58l8.42-6.89v2.89h2A24.94,24.94,0,0,1,32,38.71c.39-.55.81-1.08,1.24-1.6a27,27,0,0,0-19.67-8.53V23.47L0,34.58,13.58,45.69V40.58a15,15,0,0,1,13.67,8.85A29,29,0,0,1,28,46.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.58,69.58h-2v-14a17,17,0,0,1,17-17h2v2.89L66,34.58l-8.42-6.89v2.89h-2a25,25,0,0,0-25,25v14h-2v-14a27,27,0,0,1,27-27V23.47L69.16,34.58,55.58,45.69V40.58a15,15,0,0,0-15,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.58,30.77c.69.42,1.35.86,2,1.33V11.58H27.69l6.89-8.42,6.89,8.42H38.58V32.1c.65-.47,1.31-.92,2-1.33V13.58h5.11L34.58,0,23.47,13.58h5.11Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsIco);
export default __webpack_public_path__ + "static/media/arrows-ico.059a35a554fff99dbbe20e5e9ab01348.svg";
export { ForwardRef as ReactComponent };